var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logos"},_vm._l((_vm.logos),function(logo){return _c('img',{key:logo.alt,attrs:{"src":logo.src,"alt":logo.alt}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }